import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { CModelRepo as cModelRepo } from '@services/cmodel.repo';
import { CModelUtilities as cModelUtilities } from '@common/cmodel.utilities';
import { cModel } from './cmodel';
import { cModelInternational } from './cmodel.international/cmodel.international';
import { cModelMauritius } from './cmodel.mauritius/cmodel.mauritius';
import { cModelSecurityManagement } from './cmodel.securitymanagement/cmodel.securitymanagement';
import { itemTemplate } from './modaltemplates/itemtemplate';
import { ItemTemplateController } from './modaltemplates/itemtemplate';
import { cModelDialog } from './cmodel.mauritius/cmodel.dialog';
import { editSecurityDialog } from './cmodel.securitymanagement/editSecurity.Dialog';
import { reportSummary } from './cmodel.marketAnalysis/reportSummary';
import { selectDateDialog } from './cmodel.marketAnalysis/selectDateDialog/selectdate.dialog';
import { SecurityDetailsTable } from './cmodel.securitymanagement/securityDetailTable.component';
import { ReportsRepo } from '@services/reports.repo';


export const cModelModule = 'cmodel';

angular
  .module(cModelModule, ['xeditable'])
  .constant("config", constants.Default)
  .service('cModelRepo', cModelRepo)
  .service('cModelUtilities', cModelUtilities)
  .service('reportsRepo', ReportsRepo)
  .component('cModel', cModel)
  .component('cModelInternational', cModelInternational)
  .component('cModelMauritius', cModelMauritius)
  .component('cModelSecurityManagement', cModelSecurityManagement)
  .component('itemTemplate', itemTemplate)
  .component('cModelDialog', cModelDialog)
  .component('reportSummary', reportSummary)
  .component('selectDateDialog', selectDateDialog)
  .component('editSecurityDialog', editSecurityDialog)
  .component('securityDetailsTable', SecurityDetailsTable)
  .controller('ItemTemplateController', ItemTemplateController)



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.index.ts